var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 9h32M28 17c.4706-2.6667 2.3294-8 6-8M28 1c.4706 2.6667 2.3294 8 6 8","stroke":"#000"}));
}

Arrow.defaultProps = {"width":"35","height":"18","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
